/**
 * Video portfolio (public /portfolio page + home showcase + nav links).
 * Set to true when you want to restore the page.
 */
export const VIDEO_PORTFOLIO_ENABLED = true;
